import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { MembershipBaseModel } from '@smarttask-common/src/lib/models/Membership/Core/MembershipBaseModel';
import { MembershipAccessModel } from '@smarttask-common/src/lib/models/Membership/MembershipAccessModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class MembershipHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.membership_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.membership_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.membership_access_update, (access_model: MembershipAccessModel) => {
            this.broadcast(SharedEventNameEnum.membership_access_update, { access_model });
        });

        this.on(SharedEventNameEnum.membership_add, (members: Array<MembershipBaseModel>) => {
            this.broadcast(SharedEventNameEnum.membership_add, { members });
        });

        this.on(SharedEventNameEnum.membership_update_role, (members: Array<MembershipBaseModel>) => {
            this.broadcast(SharedEventNameEnum.membership_update_role, { members });
        });

        this.on(SharedEventNameEnum.membership_remove, (members: Array<MembershipBaseModel>) => {
            this.broadcast(SharedEventNameEnum.membership_remove, { members });
        });
    };
}
